import React from 'react';

const SliderContext = React.createContext(null);

export default SliderContext;